<template lang="pug">
v-container(:style="containerStyles")
  v-row.pb-1
    v-avatar(:size="imageSize", :style="borderStyles", @click="goToProfile")
      v-img(:alt="name", :src="imageUrl")
        template(v-slot:placeholder)
          v-row.fill-height.ma-0(
            align="center",
            justify="center",
            :style="firstRibbonStyles"
          )
            v-icon(dark, v-if="!clients.length") {{ userIcon }}

  v-row(
    align="center",
    justify="center",
    v-if="variant !== 'sm' || variant !== 'xs' || variant !== 'xxs'"
  )
    v-col.d-flex.align-center.justify-center(
      v-for="client in clients",
      :key="client.name",
      cols="3",
      :style="thumbsStyles"
    )
      v-tooltip(bottom)
        template(v-slot:activator="{ on, attrs }")
          v-avatar(
            :size="thumbSize",
            :style="borderStyles",
            v-bind="attrs",
            v-on="on"
          ) 
            v-row.fill-height.ma-0(
              align="center",
              justify="center",
              :style="getRibbonStyles(client.ribbon_css)"
            )
        span {{ client.name }}
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import { mdiAccountCircleOutline } from "@mdi/js"
import { Client } from "suus-api"
import { goToUrl } from "../../helpers/navigation"
export default Vue.extend({
  name: "Avatar",
  props: {
    name: { type: String, default: "avatar" },
    imageUrl: { type: String, required: false },
    profileUrl: { type: String, required: false },
    variant: {
      type: String,
      default: "lg",
      validator: (val: string) => ["xxs", "xs", "sm", "md", "lg"].includes(val),
    },
    size: { type: Number, default: 100 },
    clients: { type: Array as PropType<Client[]>, default: () => [] },
  },
  data: () => ({
    userIcon: mdiAccountCircleOutline,
  }),
  computed: {
    imageSize() {
      switch (this.variant) {
        case "xxs":
          return 36
        case "xs":
          return 50
        case "sm":
          return 60
        case "md":
          return 80
        default:
          return 110
      }
    },
    thumbSize() {
      switch (this.variant) {
        case "xs":
          return 12
        case "sm":
          return 14
        case "md":
          return 18
        default:
          return 24
      }
    },
    containerStyles(): object {
      return {
        width: `${this.imageSize}px`,
      }
    },
    thumbsStyles(): object {
      return {
        minHeight: this.thumbSize * 1.5,
        padding: `${this.thumbSize / 8}px 0 0 0`,
      }
    },
    defaultStyles(): string {
      return `background-color: ${this.$vuetify.theme.themes.light.primary};`
    },
    borderStyles(): object {
      return {
        border: `1px solid white`,
        boxShadow: `0px 0px 16px 1px ${this.$vuetify.theme.themes.light.mediumGrey}`,
      }
    },
    firstRibbonStyles(): string {
      let styles = `${this.clients[0]?.ribbon_css}; transform: rotate(-45deg);`
      return this.clients.length ? styles : this.defaultStyles
    },
  },
  methods: {
    getRibbonStyles(ribbon_css: string): string {
      return `${ribbon_css};${"transform: rotate(-45deg)"}; `
    },
    goToProfile() {
      if (this.profileUrl) goToUrl(this.profileUrl)
    },
  },
})
</script>
